// extracted by mini-css-extract-plugin
export default {"centralize":"SearchBar_centralize__XWWUJ","inputBlock":"SearchBar_inputBlock__5naXP","placeholder":"SearchBar_placeholder__vKmrA"};